export const SystemParametersEnum = {
    TINYMCE_API_KEY: "TINYMCE_API_KEY"
}